import ErrorMessage from './error-message.js';
import buildError, { buildErrorContainer } from './error-template.js';
import NotFoundErrorContent from './not-found-error-content/index.js';
import Schema from './schema-error/index.js';

export const SchemaError = buildErrorContainer(Schema);
export const NotFoundError = buildError(NotFoundErrorContent);
export const CustomError = buildError(ErrorMessage);
export const GenericError = buildError();

export { default as ErrorMessage } from './error-message.js';
